module.exports = __webpack_public_path__ + "img/empty-logo-vertical.c2fa0181.svg";